import React from 'react';
import { useAppSelector } from '@shared/hooks/use-app-selector';
import { StyleProvider } from './StyleProvider';
import { MessageDisplayer } from '@shared/components/MessageDisplayer';

export function DesignSystemProvider({ children }: React.PropsWithChildren) {
  const currentMerchant = useAppSelector((state) => state.currentMerchant);
  const initialization = useAppSelector(
    (state) => state.initialization as { success?: boolean } | undefined
  );

  const merchantId = currentMerchant?.id || '';
  const merchantSource = currentMerchant?.source || '';

  if (!initialization?.success) {
    return <>{children}</>;
  }

  if (merchantId && merchantSource === 'onecom_wsb') {
    const GravityProvider = require('./GravityProvider').GravityProvider;
    return <GravityProvider children={children} />;
  }

  const AntdProvider = require('./AntdProvider').AntdProvider;
  return (
    <AntdProvider>
      <StyleProvider>
        <MessageDisplayer />
        {children}
      </StyleProvider>
    </AntdProvider>
  );
}
